import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12 p-md-8" }
const _hoisted_3 = { class: "p-fluid p-grid p-formgrid" }
const _hoisted_4 = { class: "p-field p-col-6 p-md-6" }
const _hoisted_5 = { for: "endDate" }
const _hoisted_6 = { class: "p-d-flex p-ai-center" }
const _hoisted_7 = { class: "p-d-flex p-ai-center" }
const _hoisted_8 = { class: "p-d-flex p-jc-between" }
const _hoisted_9 = { class: "p-input-icon-left" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_12 = { class: "p-d-flex p-ai-center" }
const _hoisted_13 = { class: "p-pl-2" }
const _hoisted_14 = { class: "p-d-flex p-jc-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataRole = _resolveComponent("DataRole")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modal: true,
    header: _ctx.$t('automl.create.advanced.setting'),
    class: "advanced-setting-dialog"
  }, {
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_Button, {
          label: _ctx.$t('automl.create.setting'),
          disabled: _ctx.isDisableSettingButton,
          onClick: _ctx.onClickSetting,
          autofocus: ""
        }, null, 8, ["label", "disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("automl.create.limit.time.label")), 1),
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedLimitTime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedLimitTime = $event)),
                options: _ctx.limitTimeList,
                optionLabel: "label",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeLimitTime($event)))
              }, {
                value: _withCtx((slotProps) => [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("div", null, _toDisplayString(_ctx.$t(slotProps.value.label)), 1)
                  ])
                ]),
                option: _withCtx((slotProps) => [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ])
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("h6", null, _toDisplayString(_ctx.$t("automl.create.feature.label")), 1),
        _createVNode(_component_DataTable, {
          value: _ctx.autoMlSchemas,
          responsiveLayout: "scroll",
          selectionMode: "multiple",
          metaKeySelection: false,
          selection: _ctx.selectedColumn,
          "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedColumn = $event)),
          filters: _ctx.filters,
          "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters = $event))
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters['global'].value = $event)),
                  placeholder: _ctx.$t('automl.create.search')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("automl.create.not.found")), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              selectionMode: "multiple",
              style: {"width":"3rem"}
            }),
            _createVNode(_component_Column, {
              field: "name",
              header: _ctx.$t('automl.create.column.name')
            }, null, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "role",
              header: _ctx.$t('automl.create.column.role')
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.role)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode(_component_DataRole, {
                        role: slotProps.data.role
                      }, null, 8, ["role"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "type",
              header: _ctx.$t('automl.create.column.type')
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_DataType, {
                    dataType: slotProps.data.type
                  }, null, 8, ["dataType"]),
                  _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t(`datasource.datatype.${slotProps.data.type}`)), 1)
                ])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["value", "selection", "filters"])
      ])
    ]),
    _: 1
  }, 8, ["header"]))
}